import { Skeleton, Empty } from 'antd'
import { useEffect, useState } from 'react'
import { t } from 'i18next'

export const LoadingEmpty = ({ loading, height = 440, firstLoading }) => {
    const [first, setFirst] = useState(true)
    const firstHeight = firstLoading ?? 60
    useEffect(() => {
        if (loading) setFirst(false)
    }, [loading]) // 加载数据后，关闭

    if (first) return <div style={{ height: height - firstHeight ?? 128 + 'px' }}></div> // 加载数据前
    if (loading) return <Skeleton paragraph={{ rows: height ? Math.round(height / 48) : 4 }} /> // 加载接口数据中
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('common.tips25')} /> // 默认情况下（渲染空值组件）：1. 空数据，null 或者 undefined， 2. 空数组等，
}
